/**
 * Wat de leerkracht aan de server vraagt: één functie per endpoint.
 *
 * Elke functie geeft de JSON van de server terug ({ success, data, detail }).
 * Een mislukte verbinding komt als fout uit fetch; het tabblad beslist
 * wat de leerkracht dan ziet.
 */
import { maakJson, stellingenEnPersonas } from './gedeeld';

export function maakLeerkrachtApi(verzoek) {
  const h = maakJson(verzoek);
  const { json, post, verwijder, postParams } = h;

  return {
    ...stellingenEnPersonas(h),

    // klassen en leerlingen
    haalKlassen: () => json('/admin/classes'),
    haalKlas: (id) => json('/admin/classes/' + id),
    maakKlas: (naam, leerjaar, teacherId, schoolId) =>
      postParams('/admin/classes', { naam, leerjaar, teacher_id: teacherId, school_id: schoolId }),
    verwijderKlas: (id) => verwijder('/admin/classes/' + id),
    maakLeerling: (leerling, klasId, schoolId) =>
      postParams('/admin/students', { ...leerling, class_id: klasId, school_id: schoolId }),
    verwijderLeerling: (id) => verwijder('/admin/students/' + id),

    // de chatsamenstelling per stelling en leerjaar
    haalSamenstelling: (stellingId) => json('/admin/statements/' + stellingId + '/agent-config'),
    haalStellingPersonas: (stellingId) => json('/admin/statements/' + stellingId + '/personas'),
    slaStellingPersonasOp: (stellingId, leerjaar, personaIds) =>
      post('/admin/statements/' + stellingId + '/personas', { persona_ids: personaIds, leerjaar }),
    slaSamenstellingOp: (stellingId, samenstelling) => post('/admin/statements/' + stellingId + '/agent-config', samenstelling),

    // lessen (sessies) en hun resultaten
    haalSessies: () => json('/admin/sessions'),
    maakSessie: (sessie) => postParams('/admin/sessions', sessie),
    zetSessie: (id, actief) => json('/admin/sessions/' + id + '/' + (actief ? 'activate' : 'deactivate'), { method: 'PUT' }),
    verwijderSessie: (id) => verwijder('/admin/sessions/' + id),
    haalResultaten: (sessieId) => json('/admin/sessions/' + sessieId + '/results'),
  };
}
